<template>
    <footer class="aar-footer">
        <div class="component-container py-16">
            <img loading="lazy" width="86" heigth="52" src="../assets/images/logo.png" alt="" class="aar-footer__logo col-start-1 col-end-3">
            <hr class="col-start-1 col-end-13">
            <div class="aar-footer__contact  md:col-start-6 lg:col-start-7 xl:col-start-9 col-end-13">
                <a href="mailto:info@accadijital.com" class="aar-footer__contact-container mobile-scale">
                    <img loading="lazy" width="32" height="32" src="../assets/images/mail.png" alt="" class="aar-footer__contact-img">
                    <span class="aar-footer__contact-text">info@accadigital.com</span>
                </a>
                <a href="tel:0902168025348" class="aar-footer__contact-container mobile-scale whitespace-nowrap">
                    <img loading="lazy" width="32" height="32" src="../assets/images/phone.png" alt="" class="aar-footer__contact-img">
                    <span class="aar-footer__contact-text">+90 216 802 53 48</span>
                </a>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'ACFooter',
  data(){
      return {

      }
  }
}

</script>

<style scoped lang="scss">

  @import "../styles/core/variables.scss";

    footer.aar-footer{
        display: flex;
        flex-direction: row;
        height: $footer-height;
        background-color: #0A0A0A;
        color: white;
    }

    .aar-footer {
    
        &__content { 
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        grid-column: 2 / 12;
        }

        &__logo {

        }

        &__contact {
            display: flex;
            align-self: flex-end;

        }
        
        &__contact-container {
            display: flex;
            align-items: center;
            font-family: $main-font;
            color: white;
            text-decoration: none;
            font-size: 1.4rem;

            &:not(:last-child) {
                margin-right: 3.5rem;
            }
        }
    }

    hr {
        width: 100%;
    }

    img.aar-footer__contact-img {
        margin-right: 1rem;
    }


    // Footer - Mobile Responsive

    @media screen and (max-width: $mobile-small){

    .component-container{
        display: flex;
        width: 100%;
        justify-content: center;;
    }

    .footer.aar-footer{
        height: $footer-height-mobile;
    }


    .aar-footer__contact {
        align-self: center;
    }
    
    .aar-footer__contact-container{
        display: flex;
        flex-direction: column;
    }

    span.aar-footer__contact-text {
        font-family: "Inter";
        font-size: 1.4rem;
        white-space: nowrap;
        letter-spacing: -0.03em;
        margin-top: 2rem;
    }

    .aar-footer__logo{
        display: none;
    }

    hr{
        display: none;
    }
    
}

</style>
